export const SHOW_PARKING_PROGRESS_POPUP = 'SHOW_PARKING_PROGRESS_POPUP'

export function showParkingInProgressPopUpReducer (state = false, action) {
    switch (action.type){
        case SHOW_PARKING_PROGRESS_POPUP:
            return action.payload
        default: return state
    }
}